export default "__VITE_ASSET__DVSP7u9w__"